import * as React from "react";

import {cs}            from "@Common/react/chain-services";
import {parseUrlQuery} from "@Common/utils/parse-url-query";

import {AccountHeadshotsPanel} from "../../../../common/headshots-panel/headshots-panel";
import {UserAssetsLayout}      from "../common/layout/user-assets-layout";

export const AccountAdminHeadshotsRoute = () => cs(
    ["layout", ({}, next) => UserAssetsLayout({activeTab: "admin-headshots", next})],
    ["agentId", ({}, next) => next(parseUrlQuery(window.location.search)?.agent)],
    ({agentId, layout}) => AccountHeadshotsPanel({
        agentId,
        onReloadHeadshot: layout.reload,
    }),
);
